import "./inc/retail_user.js";
import "./inc/form_city_filter.js";
import "./inc/nav_dropdown.js";
import "./inc/map_infowindow.js";
import { Fancybox } from "@fancyapps/ui";
import * as bootstrap from "bootstrap";

import { gsap } from "gsap";
    
import { ScrollTrigger } from "gsap/ScrollTrigger";
// ScrollSmoother requires ScrollTrigger
import { ScrollSmoother } from "gsap/ScrollSmoother";

gsap.registerPlugin(ScrollTrigger,ScrollSmoother);

// Expose gsap/ScrollTrigger on the window object so page templates can use them in inline scripts.
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;

// oilib.js needs bootstrap to be available on the window object. It uses bootstrap popovers (maybe others, too).
window.bootstrap = bootstrap;

import Swiper from 'swiper/bundle';
window.Swiper = Swiper;

// ========================
// == Trigger Tabs By Hash
var triggerTabList = [].slice.call(document.querySelectorAll(".tab-btn"));

triggerTabList.forEach(function (triggerEl) {
  var tabTrigger = new bootstrap.Tab(triggerEl);
  var hash = '#' + triggerEl.href.split("#")[1];
  var tabBtn = document.querySelector( hash + "-tab");

  triggerEl.addEventListener("click", function (event) {
    event.preventDefault();
    tabBtn.click();
  })
})
// END Trigger Tabs By Hash
// ========================

// ========================
// == Add class to main navbar on scroll

const el = document.querySelector('#site-nav');

if (el) {
    const setNavScrolled = () => {
        if (window.scrollY > 60) {
            el.classList.add('scrolled');
        } else if (window.scrollY < 10) {
            el.classList.remove('scrolled');
        }
    };

    setNavScrolled();
    window.addEventListener('scroll', setNavScrolled, { passive: true });

    const setNavHeight = () => {
        document.documentElement.style.setProperty('--site-nav-height', el.offsetHeight + 'px');
    };

    setNavHeight();
    window.addEventListener('resize', setNavHeight);
    el.addEventListener('transitionend', setNavHeight);
}

let hasUserScrolled = false;

['wheel', 'touchstart', 'keydown'].forEach((type) => {
    window.addEventListener(type, () => {
        hasUserScrolled = true;
    }, { once: true, passive: true });
});

window.addEventListener('load', () => {
    document.fonts.ready.then(() => {
        const target = window.location.hash ? document.getElementById(decodeURIComponent(window.location.hash.slice(1))) : null;
        if (target && !hasUserScrolled) {
            target.scrollIntoView({ block: 'start' });
        }
    });
});

// END scrolled
// ========================

// ========================
// == Panzoom =============

const panzoom = document.querySelector(".panzoom");
const panzoom_reset = document.querySelector(".panzoom-reset");
const panZoomImg = document.querySelector('.panzoom__content');
const fpImgLink = document.querySelectorAll("[data-imgurl]");

if (panzoom) {
    const myPanzoom = new Panzoom(panzoom, {
        minScale:0.5,
        maxScale:3,
    });
    panzoom_reset.addEventListener("click", function (event) {
        myPanzoom.zoomTo(1);
    })
}

for (const link of fpImgLink) {
    link.addEventListener('click', function () {
        fpImgLink.forEach((e)=> {e.classList.remove('active-bg')})
        link.classList.add('active-bg');
        var imgUrl = link.dataset.imgurl;
        console.log(imgUrl);
        panZoomImg.src = imgUrl;
    });
}

// END Panzoom ============
// ========================

/*
 * FANCYBOX
 *
 * The new Fancybox v4 (non-jQuery) triggers a "done" event for up to three images when
 * the carousel is first initilaized. To avoid triggering 3 image view events on every
 * Fancybox initCarousel action, an imageview event is triggered on the initCarousel
 * event, but "done" events are then ignored for 1 second. After 1 second, image view
 * events will be triggered as typical.
 */

// Tracks fancybox image views.
let fancyboxEventBlock = false

/** Abstracted event action handler
 * @param {import("@fancyapps/ui").Fancybox} fancybox
 */
const doFancyboxOiEvent = (fancybox) => {
    if (fancybox.options.trigger.dataset.oiEventName) {
        let oi_event_name = fancybox.options.trigger.dataset.oiEventName;
        if ("undefined" != typeof window.dataLayer) {
            window.dataLayer.push({ event: oi_event_name });
        }
        if ("undefined" != typeof window.hfaDataLayer) {
            window.hfaDataLayer.push({ event: oi_event_name });
        }
    }
}

// Bind actions to Fancybox events
Fancybox.bind("[data-fancybox]", {
    on: {
        initCarousel: (fancybox) => {
            if(!fancyboxEventBlock) {
                // Block additional Fancybox events
                fancyboxEventBlock = true

                // Do Fancybox event
                doFancyboxOiEvent(fancybox)

                // Undo the event block after 1 second.
                setTimeout(() => {
                    fancyboxEventBlock = false
                }, 1000)
            }
        },
        done: (fancybox, slide) => {
            if(!fancyboxEventBlock) {
                // Do Fancybox event
                doFancyboxOiEvent(fancybox)
            }
        },
        destroy: () => {
            // Reset the block on Fancybox close.
            fancyboxEventBlock = false
        },
    },
});

/* END FANCYBOX */


// This fires the oi.utils function that will wrap all iframes contained in WYSIWYG
// editors with appropriate oi-aspect classes.

window.addEventListener('load', function () {
  oi.utils.wrap_oi_aspect();
}, false);



let mm = gsap.matchMedia();

mm.add("(min-width: 992px)", () => {
    gsap.registerPlugin(ScrollTrigger);

    var panels = gsap.utils.toArray(".panel-wrapper");
    panels.pop();

    panels.forEach((panel, i) => {
    
    // Get the element holding the content inside the panel
    let innerpanel = panel.querySelector(".inner-panel");
    
    // Get the Height of the content inside the panel
    let panelHeight = innerpanel.offsetHeight;
    console.log(panelHeight)
    
    // Get the window height
    let windowHeight = window.innerHeight;
    
    let difference = panelHeight - windowHeight;
    
    // ratio (between 0 and 1) representing the portion of the overall animation that's for the fake-scrolling. We know that the scale & fade should happen over the course of 1 windowHeight, so we can figure out the ratio based on how far we must fake-scroll
    let fakeScrollRatio = difference > 0 ? (difference / (difference + windowHeight)) : 0;
    
    // if we need to fake scroll (because the panel is taller than the window), add the appropriate amount of margin to the bottom so that the next element comes in at the proper time.
    if (fakeScrollRatio) {
        panel.style.marginBottom = panelHeight * fakeScrollRatio + "px";
    }
    
    let tl = gsap.timeline({
        scrollTrigger:{
        trigger: panel,
        start: "bottom bottom",
        end: () => fakeScrollRatio ? `+=${innerpanel.offsetHeight}` : "bottom 100px",
        pinSpacing: false,
        pin: true,
        //markers: true,
        scrub: true
        }
    });
    
    // fake scroll. We use 1 because that's what the rest of the timeline consists of (0.9 scale + 0.1 fade)
    if (fakeScrollRatio) {
        tl.to(innerpanel, {yPercent:-100, y: window.innerHeight, duration: 1 / (1 - fakeScrollRatio) - 1, ease: "none"});
    }
    tl.fromTo(panel, {scale:1, opacity:1}, {scale: 0.7, opacity: 0.5, duration: 0.9})
        .to(panel, {opacity:0, duration: 0.1});
    });

});